import {
  INIT_URL,
  SIGNOUT_USER_SUCCESS,
  USER_DATA,
  USER_TOKEN_SET,
  ACTIVATE_USER_INIT,
  ACTIVATE_USER_SUCCESS,
  ACTIVATE_USER_ERROR,
  ACTIVATION_CODE_RECREATE_SUCCESS,
  FETCH_ROLES_START,
  FETCH_ROLES_SUCCESS,
  FETCH_ROLES_ERROR,
  FETCH_USERS_START,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_ERROR,
  FETCH_PERMISSIONS_START,
  FETCH_PERMISSIONS_SUCCESS,
  FETCH_PERMISSIONS_ERROR,
  ADD_PERMISSIONS_START,
  ADD_PERMISSIONS_SUCCESS,
  ADD_PERMISSIONS_ERROR,
  DELETE_PERMISSIONS_START,
  DELETE_PERMISSIONS_SUCCESS,
  DELETE_PERMISSIONS_ERROR,
  UPDATE_PERMISSIONS_START,
  UPDATE_PERMISSIONS_SUCCESS,
  UPDATE_PERMISSIONS_ERROR,
  ADD_ROLE_START,
  ADD_ROLE_SUCCESS,
  ADD_ROLE_ERROR,
  DELETE_ROLE_START,
  DELETE_ROLE_SUCCESS,
  DELETE_ROLE_ERROR,
  UPDATE_ROLE_START,
  UPDATE_ROLE_SUCCESS,
  UPDATE_ROLE_ERROR,
  UPDATE_USER_START,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_ERROR,
  ADD_USER_START,
  ADD_USER_SUCCESS,
  ADD_USER_ERROR,
  SET_SELECTED_USER,
  SET_FORGOT_PASSWORD_EMAIL,
  PASSWORD_RESET_INIT,
  PASSWORD_RESET_SUCCESS,
  PASSWORD_RESET_ERROR,
  FETCH_RECAPTCHA_INIT,
  FETCH_RECAPTCHA_SUCCESS,
  FETCH_RECAPTCHA_ERROR,
  VERIFY_MFA_TOKEN_START,
  VERIFY_MFA_TOKEN_SUCCESS,
  VERIFY_MFA_TOKEN_ERROR,
  GET_MFA_QRCODE_START,
  GET_MFA_QRCODE_SUCCESS,
  GET_MFA_QRCODE_ERROR,
  TOGGLE_MFA_TOKEN_START,
  TOGGLE_MFA_TOKEN_SUCCESS,
  TOGGLE_MFA_TOKEN_ERROR,
  CHANGE_PAGE_LIMIT,
  CHANGE_PAGE,
  SIGNUP_USER_SUCCESS,
} from 'constants/ActionTypes';
import { SELECTED_USER_DATA } from '../../constants/ActionTypes';
import encryptStorage from '../../util/encryption';

const INIT_STATE = {
  token: encryptStorage.getItem('token') || null,
  registrationToken: null,
  initURL: '',
  authUser: encryptStorage.getItem('user') || null,
  activateUser: {
    loading: false,
    error: null,
    data: {},
  },
  activationCode: null,
  roles: {
    data: [],
    loading: false,
    error: null,
    addingRole: false,
    deletingRole: false,
    updatingRole: false,
    currentPage: 1,
    pageSize: 10,
    totalItems: 10,
  },
  permissions: {
    data: [],
    loading: false,
    error: null,
    addingPermission: false,
    deletingPermission: false,
    updatingPermission: false,
    addingPermissionError: null,
    currentPage: 1,
    pageSize: 10,
    totalItems: 10,
  },
  users: {
    data: [],
    loading: false,
    error: null,
    updatingUser: false,
    currentPage: 1,
    pageSize: 10,
    totalItems: 10,
  },
  selectedUser: {},
  forgotPasswordMail: encryptStorage.getItem('forgotEmail'),
  passwordReset: {
    loading: false,
    error: null,
    message: '',
  },
  verifiedRecaptcha: {
    loading: false,
    error: null,
    status: false,
  },
  verifyMFAToken: {
    loading: false,
    error: null,
    message: '',
  },
  getQRCode: {
    loading: false,
    error: null,
    message: '',
  },
  toggleMFAToken: {
    loading: false,
    error: null,
    message: '',
  },
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case INIT_URL: {
      return { ...state, initURL: action.payload };
    }

    case CHANGE_PAGE_LIMIT: {
      return {
        ...state,
        [action.payload.type]: {
          ...state[action.payload.type],
          pageSize: action.payload.pageSize,
        },
      };
    }

    case CHANGE_PAGE: {
      return {
        ...state,
        [action.payload.type]: {
          ...state[action.payload.type],
          currentPage: action.payload.currentPage,
        },
      };
    }

    case SIGNOUT_USER_SUCCESS: {
      return {
        ...state,
        token: null,
        authUser: null,
        initURL: '',
        verifyMFAToken: {
          loading: false,
          error: null,
          message: '',
        },
        toggleMFAToken: {
          loading: false,
          error: null,
          message: null,
        },
      };
    }

    case USER_DATA: {
      return {
        ...state,
        authUser: action.payload,
      };
    }

    case SELECTED_USER_DATA: {
      return {
        ...state,
        selectedUser: action.payload,
      };
    }

    case USER_TOKEN_SET: {
      return {
        ...state,
        token: action.payload,
      };
    }

    case SIGNUP_USER_SUCCESS: {
      return {
        ...state,
        registrationToken: action.payload,
      };
    }

    case ACTIVATE_USER_INIT: {
      return {
        ...state,
        activateUser: {
          loading: true,
        },
      };
    }

    case ACTIVATE_USER_SUCCESS: {
      return {
        ...state,
        activateUser: {
          loading: false,
          data: action.payload,
        },
      };
    }

    case ACTIVATE_USER_ERROR: {
      return {
        ...state,
        activateUser: {
          loading: false,
          error: action.payload,
        },
      };
    }

    case SET_FORGOT_PASSWORD_EMAIL: {
      encryptStorage.setItem('forgotEmail', action.payload);
      return {
        ...state,
        forgotPasswordMail: action.payload,
      };
    }

    case PASSWORD_RESET_INIT: {
      return {
        ...state,
        passwordReset: {
          ...state.passwordReset,
          loading: true,
        },
      };
    }

    case PASSWORD_RESET_SUCCESS: {
      return {
        ...state,
        passwordReset: {
          ...state.passwordReset,
          loading: false,
          message: action.payload,
        },
      };
    }

    case PASSWORD_RESET_ERROR: {
      return {
        ...state,
        passwordReset: {
          ...state.passwordReset,
          loading: false,
          error: action.payload,
        },
      };
    }

    case ACTIVATION_CODE_RECREATE_SUCCESS: {
      return {
        ...state,
        activationCode: action.payload,
      };
    }

    case FETCH_ROLES_START: {
      return {
        ...state,
        roles: {
          ...state.roles,
          loading: true,
        },
      };
    }

    case FETCH_ROLES_SUCCESS: {
      const { totalItems, currentPage, data } = action.payload;
      return {
        ...state,
        roles: {
          ...state.roles,
          loading: false,
          data,
          currentPage,
          totalItems,
        },
      };
    }

    case FETCH_ROLES_ERROR: {
      return {
        ...state,
        roles: {
          ...state.roles,
          loading: false,
          error: action.payload,
        },
      };
    }

    case ADD_ROLE_START: {
      return {
        ...state,
        roles: {
          ...state.roles,
          addingRole: true,
        },
      };
    }

    case ADD_ROLE_SUCCESS: {
      const allRoles = state.roles.data;
      allRoles.push(action.payload);
      return {
        ...state,
        roles: {
          ...state.roles,
          addingRole: false,
          data: allRoles,
        },
      };
    }

    case ADD_ROLE_ERROR: {
      return {
        ...state,
        roles: {
          ...state.roles,
          addingRole: false,
        },
      };
    }

    case DELETE_ROLE_START: {
      return {
        ...state,
        roles: {
          ...state.roles,
          deletingRole: true,
        },
      };
    }

    case DELETE_ROLE_SUCCESS: {
      const updatedData = state.roles.data.filter(
        (role) => role._id !== action.payload,
      );
      return {
        ...state,
        roles: {
          ...state.roles,
          deletingRole: false,
          data: updatedData,
        },
      };
    }

    case DELETE_ROLE_ERROR: {
      return {
        ...state,
        roles: {
          ...state.roles,
          deletingRole: false,
        },
      };
    }

    case UPDATE_ROLE_START: {
      return {
        ...state,
        roles: {
          ...state.roles,
          updatingRole: true,
        },
      };
    }

    case UPDATE_ROLE_SUCCESS: {
      const allRoles = state.roles.data;
      const updatedData = allRoles.filter(
        (role) => role._id !== action.payload._id,
      );
      updatedData.push(action.payload);
      return {
        ...state,
        roles: {
          ...state.roles,
          updatingRole: false,
          data: updatedData,
        },
      };
    }

    case UPDATE_ROLE_ERROR: {
      return {
        ...state,
        roles: {
          ...state.roles,
          updatingRole: false,
        },
      };
    }

    case FETCH_USERS_START: {
      return {
        ...state,
        users: {
          ...state.users,
          loading: true,
        },
      };
    }

    case FETCH_USERS_SUCCESS: {
      const { totalItems, currentPage, data } = action.payload;
      return {
        ...state,
        users: {
          ...state.users,
          loading: false,
          data,
          currentPage,
          totalItems,
        },
      };
    }

    case FETCH_USERS_ERROR: {
      return {
        ...state,
        users: {
          ...state.users,
          loading: false,
          error: action.payload,
        },
      };
    }

    case UPDATE_USER_START: {
      return {
        ...state,
        users: {
          ...state.users,
          updatingUser: true,
        },
      };
    }

    case UPDATE_USER_SUCCESS: {
      const updatedData = state.users.data;
      const index = updatedData.findIndex(
        (key) => key._id === action.payload._id,
      );
      updatedData[index] = action.payload;
      return {
        ...state,
        users: {
          ...state.users,
          updatingUser: false,
          data: updatedData,
        },
      };
    }

    case UPDATE_USER_ERROR: {
      return {
        ...state,
        users: {
          ...state.users,
          updatingUser: false,
        },
      };
    }

    case ADD_USER_START: {
      return {
        ...state,
        users: {
          ...state.users,
          addingUser: true,
        },
      };
    }

    case ADD_USER_SUCCESS: {
      return {
        ...state,
        users: {
          ...state.users,
          addingUser: false,
          data: [action.payload, ...state.users.data],
        },
      };
    }

    case ADD_USER_ERROR: {
      return {
        ...state,
        users: {
          ...state.users,
          addingUser: false,
        },
      };
    }

    case FETCH_PERMISSIONS_START: {
      return {
        ...state,
        permissions: {
          ...state.permissions,
          loading: !action.search,
          searching: !!action.search,
        },
      };
    }

    case FETCH_PERMISSIONS_SUCCESS: {
      const {
        totalItems, currentPage, data, search,
      } = action.payload;
      return {
        ...state,
        permissions: {
          ...state.permissions,
          loading: false,
          searching: false,
          data,
          totalItems,
          currentPage,
          searchResults: search ? data : [],
        },
      };
    }

    case FETCH_PERMISSIONS_ERROR: {
      return {
        ...state,
        permissions: {
          ...state.permissions,
          loading: false,
          error: action.payload,
        },
      };
    }

    case ADD_PERMISSIONS_START: {
      return {
        ...state,
        permissions: {
          ...state.permissions,
          addingPermission: true,
        },
      };
    }

    case ADD_PERMISSIONS_SUCCESS: {
      const allPermissions = state.permissions.data;
      allPermissions.push(action.payload);
      return {
        ...state,
        permissions: {
          ...state.permissions,
          addingPermission: false,
          data: allPermissions,
        },
      };
    }

    case ADD_PERMISSIONS_ERROR: {
      return {
        ...state,
        permissions: {
          ...state.permissions,
          addingPermission: false,
          addingPermissionError: action.payload,
        },
      };
    }

    case DELETE_PERMISSIONS_START: {
      return {
        ...state,
        permissions: {
          ...state.permissions,
          deletingPermission: true,
        },
      };
    }

    case DELETE_PERMISSIONS_SUCCESS: {
      const updatedData = state.permissions.data.filter(
        (permission) => permission._id !== action.payload,
      );
      return {
        ...state,
        permissions: {
          ...state.permissions,
          deletingPermission: false,
          data: updatedData,
        },
      };
    }

    case DELETE_PERMISSIONS_ERROR: {
      return {
        ...state,
        permissions: {
          ...state.permissions,
          deletingPermission: false,
        },
      };
    }

    case UPDATE_PERMISSIONS_START: {
      return {
        ...state,
        permissions: {
          ...state.permissions,
          updatingPermission: true,
        },
      };
    }

    case UPDATE_PERMISSIONS_SUCCESS: {
      const allPermissions = state.permissions.data;
      const updatedData = allPermissions.filter(
        (permission) => permission._id !== action.payload._id,
      );
      updatedData.push(action.payload);
      return {
        ...state,
        permissions: {
          ...state.permissions,
          updatingPermission: false,
          data: updatedData,
        },
      };
    }

    case UPDATE_PERMISSIONS_ERROR: {
      return {
        ...state,
        permissions: {
          ...state.permissions,
          updatingPermission: false,
        },
      };
    }

    case SET_SELECTED_USER: {
      return {
        ...state,
        selectedUser: action.payload,
      };
    }

    case FETCH_RECAPTCHA_INIT: {
      return {
        ...state,
        verifiedRecaptcha: {
          ...state.verifiedRecaptcha,
          loading: true,
        },
      };
    }

    case FETCH_RECAPTCHA_SUCCESS: {
      return {
        ...state,
        verifiedRecaptcha: {
          ...state.verifiedRecaptcha,
          status: true,
          loading: false,
        },
      };
    }

    case FETCH_RECAPTCHA_ERROR: {
      return {
        ...state,
        verifiedRecaptcha: {
          ...state.verifiedRecaptcha,
          loading: false,
          error: action.payload,
        },
      };
    }

    case VERIFY_MFA_TOKEN_START: {
      return {
        ...state,
        verifyMFAToken: {
          ...state.verifyMFAToken,
          loading: true,
        },
      };
    }

    case VERIFY_MFA_TOKEN_SUCCESS: {
      return {
        ...state,
        verifyMFAToken: {
          ...state.verifyMFAToken,
          loading: false,
          message: action.payload,
        },
      };
    }

    case VERIFY_MFA_TOKEN_ERROR: {
      return {
        ...state,
        verifyMFAToken: {
          ...state.verifyMFAToken,
          loading: false,
          error: action.payload,
        },
      };
    }

    case GET_MFA_QRCODE_START: {
      return {
        ...state,
        getQRCode: {
          ...state.getQRCode,
          loading: true,
        },
      };
    }

    case GET_MFA_QRCODE_SUCCESS: {
      return {
        ...state,
        getQRCode: {
          ...state.getQRCode,
          loading: false,
          message: action.payload,
        },
      };
    }

    case GET_MFA_QRCODE_ERROR: {
      return {
        ...state,
        getQRCode: {
          ...state.getQRCode,
          loading: false,
          error: action.payload,
        },
      };
    }

    case TOGGLE_MFA_TOKEN_START: {
      return {
        ...state,
        toggleMFAToken: {
          ...state.toggleMFAToken,
          loading: true,
        },
      };
    }

    case TOGGLE_MFA_TOKEN_SUCCESS: {
      return {
        ...state,
        toggleMFAToken: {
          ...state.toggleMFAToken,
          loading: false,
          message: action.payload,
        },
      };
    }

    case TOGGLE_MFA_TOKEN_ERROR: {
      return {
        ...state,
        toggleMFAToken: {
          ...state.toggleMFAToken,
          loading: false,
          error: action.payload,
        },
      };
    }

    default:
      return state;
  }
};
